 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import BOOKDESCRIPTION from '@/components/book-description'
 import TITLEPAGE from '@/components/title-page'
 import CONTENTS from '@/components/contents'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import FORTHCOMING from '@/components/forthcoming'
 import INTRODUCTION from '@/components/introduction'
 import CHAPTER001 from '@/components/chapter-001'
 import CHAPTER002 from '@/components/chapter-002'
 import APERSONALINTERLUDE from '@/components/a-personal-interlude'
 import CHAPTER003 from '@/components/chapter-003'
 import CHAPTER004 from '@/components/chapter-004'
 import LOVE_2 from '@/components/love_2'
 import CONCLUSION from '@/components/conclusion'
 import BIBLIOGRAPHY from '@/components/bibliography'
 import APPENDIXA from '@/components/appendix-a'
 import APPENDIXB from '@/components/appendix-b'
 import APPENDIXC from '@/components/appendix-c'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import IFYOULIKED from '@/components/if-you-liked'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/forthcoming",
 			"name" : "forthcoming",
 			"component" : FORTHCOMING
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/chapter-001",
 			"name" : "chapter-001",
 			"component" : CHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js